module.exports = __webpack_public_path__ + "img/Warrior-human-f-70.a1e8856b.gif";